import type { Venue } from "./catalog";
import type { SeatLayoutDefinition } from "./seat-layouts";
const checkedAt = "2026-10-18";
const sources = {
	charlotte:
		"https://ticket.clipservice.co.kr/Clipservice/CustomerCenter/Theaterdetail?num=149",
	chungmu:
		"https://www.caci.or.kr/rent/space/JSVFYStLYjlxWXN0U1R3TFZMQVd0SGZIaUM2ckZ2VUMreGRpZm55dWxFWXVhZGVGeUhHZHAycElEZWhHclF1aG1WUg==",
	lg: "https://m.lgart.com/home/display/region/content/JSVFVEttNlczRTZZaGZIYUs5ckNNM0hHTDBQRVcrak5adTFTcFE2YkVYRTBGVT0=",
};
export const expandedVenues: Venue[] = [
	{
		id: "charlotte-theater",
		slug: "charlotte-theater",
		categoryId: "performance",
		name: "샤롯데씨어터",
		region: "서울 송파구",
		addressHint: "잠실 롯데월드",
		officialUrl: "https://www.charlottetheater.co.kr/",
		officialSeatmapUrl: sources.charlotte,
		spaces: [
			{
				id: "main-hall",
				name: "샤롯데씨어터",
				sectionSuggestions: ["1층", "2층"],
			},
		],
		verifiedAt: checkedAt,
		source: "official-directory",
	},
	{
		id: "chungmu-art-center",
		slug: "chungmu-art-center",
		categoryId: "performance",
		name: "충무아트센터",
		region: "서울 중구",
		addressHint: "신당",
		officialUrl: "https://www.caci.or.kr/",
		officialSeatmapUrl: sources.chungmu,
		spaces: [
			{
				id: "grand-theater",
				name: "대극장",
				sectionSuggestions: ["1층", "2층", "3층"],
			},
		],
		verifiedAt: checkedAt,
		source: "official-directory",
	},
	{
		id: "dcube-link-art-center",
		slug: "dcube-link-art-center",
		categoryId: "performance",
		name: "디큐브 링크아트센터",
		region: "서울 구로구",
		addressHint: "신도림",
		officialUrl: "https://www.d3art.co.kr/",
		spaces: [
			{ id: "dcube-theater", name: "디큐브씨어터", sectionSuggestions: [] },
		],
		verifiedAt: "2026-10-17",
		source: "official-directory",
	},
	{
		id: "lg-arts-center-seoul",
		slug: "lg-arts-center-seoul",
		categoryId: "performance",
		name: "LG아트센터 서울",
		region: "서울 강서구",
		addressHint: "마곡",
		officialUrl: "https://www.lgart.com/",
		officialSeatmapUrl: sources.lg,
		spaces: [
			{
				id: "lg-signature-hall",
				name: "LG SIGNATURE 홀",
				sectionSuggestions: ["1층", "2층", "3층"],
			},
		],
		verifiedAt: checkedAt,
		source: "official-directory",
	},
];
export const expandedLayouts: SeatLayoutDefinition[] = expandedVenues.map(
	(venue) => {
		const space = venue.spaces[0]!;
		const booking = venue.id === "dcube-link-art-center";
		return {
			venueId: venue.id,
			spaceId: space.id,
			layoutVersionId: `LV-${venue.id}-${space.id}-directory-20261018`,
			precision: booking ? "booking" : "section",
			surfaceLabel: "무대",
			title: `${space.name} 층 정보`,
			note: booking
				? "공식 좌석 정보에 연결하지 못해 배치·층·열·좌석 수를 표시하지 않아요. 공식 예매 화면에서 좌표를 확인해 주세요."
				: "글로 확인한 층만 표시해요. 열·번호·통로와 시야는 추측하지 않고 티켓과 공식 좌석도에서 확인해요.",
			source: {
				label: booking
					? "공식 홈페이지 · 좌석 정보 재확인 필요"
					: venue.id === "charlotte-theater"
						? "예매처 클립서비스 공연장 안내"
						: "공연장 공식 시설 안내",
				url: venue.officialSeatmapUrl ?? venue.officialUrl,
				checkedAt,
			},
			floors: space.sectionSuggestions.map((floor, i) => ({
				id: `${i + 1}f`,
				label: floor,
				sections: [
					{
						id: `${i + 1}층-전체`,
						label: floor,
						shortLabel: "전체",
						position: "full",
					},
				],
			})),
		};
	},
);
